import { render, staticRenderFns } from "./DocumentosTabContent.vue?vue&type=template&id=706a8ca3"
import script from "./DocumentosTabContent.vue?vue&type=script&lang=js"
export * from "./DocumentosTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports